import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { useContext as useUsersContext } from 'components/Users/Context';
import EmptyBlock from 'components/ui/EmptyBlock';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import routes from 'app/routes';

import { useContext as useHomeContext } from 'components/Members/Home/Context';
import Breadcrumbs from 'components/new_ui/Breadcrumbs/Index';
import List from './List';

export default function Main({ chats }) {
  const navigate = useNavigate();

  const { chatId } = useParams();

  const [chat, setChat] = useState(null);

  const { dispatch: dispatchUsers, actions: actionsUsers } = useUsersContext();

  const homeContext = useHomeContext();

  const breadcrumbs = [
    {
      name: 'Home',
      path: '/members/home',
    },
    {
      name: 'Contacts',
    },
  ];

  useEffect(() => {
    if (chats !== null && chats.length > 0 && chat === null) {
      let currentChat = chats[0];
      if (chatId) {
        currentChat = chats.find((item) => item.id === chatId);
        setChat(currentChat);
      } else {
        setChat(currentChat);
        navigate(routes.members.chats.messages(currentChat.id));
      }
    }
  }, [chats]);

  useEffect(() => {
    actionsUsers.load(dispatchUsers);
  }, []);

  if (chats !== null && chats.length === 0) {
    return (
      <div className="content">
        {homeContext && <Breadcrumbs breadcrumbs={breadcrumbs} />}
        <section>
          <h1 className="mb-3">Chat</h1>
        </section>

        <section>
          <EmptyBlock text={`You will be able to reach out to your coach via chat 
          after you start your coaching journey. Check back here after connecting with 
          your first coach!`}
          />
        </section>
      </div>
    );
  }

  return (
    <div className="content">
      {homeContext && <Breadcrumbs breadcrumbs={breadcrumbs} />}
      <section>

        <div className={`d-flex gap-4 ${chat ? 'chat-open' : ''}`}>
          <div className="w-100 chat-wrapper ">
            <div className="chat-messages-wrapper">
              <Outlet context={{ setChat }} />
            </div>
          </div>
          <div className="chat-list-wrapper">
            <List setChat={setChat} currentChat={chat} chats={chats} />
          </div>
        </div>

      </section>
    </div>

  );
}

Main.propTypes = {
  chats: PropTypes.arrayOf(PropTypes.object).isRequired,
};
